import React from 'react';

export default function Form({ onSubmit, children, ...props }) {
	return <form onSubmit={event => {
		event.preventDefault();
		onSubmit();
	}} {...props}>
		{children}
	</form>;
}